<template>
<div class="text-center">
  <b-progress :value="showCurrent" :max="max" class="w-75 mx-auto"></b-progress>
  
  <p class="h3">{{ showCurrent }} / {{ max }}</p>
</div>
</template>


<script>
  export default {
    name: 'progress-bar',
    data () {
      return {
        max : 10
      }
    },
    props: {
      currentQuestion: Number
    },
    computed: {
      showCurrent: function () {
        return this.currentQuestion + 1
      }
    }
  }
</script>


<style lang="scss">
  .progress{
    background:#fff;
    height:1.2rem;
    border-radius:.6rem;
    margin-bottom:1rem;
  }
  .progress-bar{
    background-color:#75c7d3;
    border-radius:.6rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/ProgressBar.vue